/**
 * One switch for the whole app: with VITE_USE_MOCKS=true every domain service
 * exports its in-memory implementation, otherwise the HTTP one. Both satisfy
 * the same interface, so nothing outside these service files changes.
 */
export const USE_MOCKS = String(import.meta.env.VITE_USE_MOCKS ?? 'true') !== 'false'

/** Picks the implementation for a domain service. Written out at each call site so the choice stays greppable. */
export function pickService<T>(mock: T, http: T): T {
  return USE_MOCKS ? mock : http
}
